import { CustomTableMeta } from '@/models/custom-table-meta.model';
import { CustomTableParams } from '@/models/custom-table-params.model';
import { CustomTableColumn } from '@/models/custom-table-column.model';
import { Vue, Prop, Component } from 'vue-property-decorator';

import CustomTableHead from '../custom-table-head/custom-table-head.component';
import CustomTableControls from '../custom-table-controls/custom-table-controls.component';
import CustomTableContent from '../custom-table-content/custom-table-content.component';

@Component({
    components: {
        CustomTableHead,
        CustomTableContent,
        CustomTableControls,
    },
})
export default class CustomTable extends Vue {
    @Prop() public inFlight: boolean;
    @Prop() public tableData: any[];
    @Prop() public tableColumns: CustomTableColumn[];
    @Prop() public tableMeta: CustomTableMeta;
    @Prop() public tableParams: CustomTableParams;

    public handleTableParamsChanged(newParams: CustomTableParams) {
        const newTableParams = { ...this.tableParams, ...newParams};
        this.$emit('onTableParamsChanged', newTableParams);
    }

    public getTableMeta() {
        return this.tableMeta || {
            totalElements: 0,
            totalPages: 1,
            from: 0,
            to: 0,
        };
    }

}
